import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import CalculatorPage from './calculator/CalculatorPage';
import EstimatePage from './estimate/EstimatePage';
import StyleGuidePage from '../styles/StyleGuidePage';
import './layout.scss';

class Layout extends React.Component {
	constructor(props, context) {
		super(props, context);
	}
	/*********************************************
	 * Holy smokes was this not fun... routing in 
	 * react and wordpress involes a number of moving
	 * parts, most arn't well documented or engineered
	 * the switch statement below restricts react to
	 * rendering a single component for that switch.
	 * This all works with wordpresses' 
	 * [add_rewrite_rule] defined in the theme's
	 * [../../functions.php]
	 **********************************************/
	render() {
		return (
			<div>
				<Switch>
					<Route path='/calculator/:id/estimate/' component={EstimatePage} />
					<Route path='/calculator/:id?/' component={CalculatorPage} />
					<Route path='/styleguide' component={StyleGuidePage} />
				</Switch>
				
			</div>
		)
	}
}

Layout.propTypes = {
	user: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.user,
	}
}

export default connect(mapStateToProps)(Layout);


// WEBPACK FOOTER //
// ./src/components/Layout.js